var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4375 11.25L15.7813 38.4063C14.8125 39.4375 13.875 41.4688 13.6875 42.875L12.5313 53C12.125 56.6562 14.75 59.1563 18.375 58.5313L28.4375 56.8125C29.8438 56.5625 31.8125 55.5313 32.7813 54.4688L58.4375 27.3125C62.875 22.625 64.875 17.2813 57.9688 10.75C51.0938 4.28126 45.875 6.56251 41.4375 11.25Z",
    stroke: "#3741B5",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1562 15.7812C38.5 24.4063 45.5 31 54.1875 31.875",
    stroke: "#3741B5",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 68.75H65.625",
    stroke: "#3741B5",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.f48741e92db197df8c9f335d1c173caa.svg";
export { ForwardRef as ReactComponent };